// AI Generated Test
import { Component, Input } from '@angular/core';
import { SessionService } from '@monsido/core/session/session.service';

@Component({
    selector: 'page-fix-changeset-link',
    standalone: false,
    template: `<a target="_blank" aria-describedby="linkOpensInNewTab" [href]="data?.change?.value">{{data?.change?.value}}</a>`,
})
export class PageFixChangesetLinkComponent {
    @Input() data: any;

    constructor (private sessionService: SessionService) {}

    getDataTargetLink (): string | undefined {
        if (this.data && this.data.target) {

            const matches = this.data.target.match(/([a-z]+:\/\/)?[\w!#€%&\/()=\?`´\^\\¨'*-\.]+/g);
            if (matches && matches[2]) {
                const match = matches[2];
                if (!this.hasProtocol(match)) {
                    return this.prefixDomainUrl(match);
                }
                return match;
            }
        }
        return undefined;
    }

    private hasProtocol (match: string): boolean {
        return Boolean(match.match(/^([a-z]+:\/\/)/));
    }

    private prefixDomainUrl (match: string): string | undefined {
        const domain = this.sessionService.domain;
        if (domain) {
            const domainUrl = domain.url;
            return domainUrl.replace(/\/$/, '') + '/' + match.replace(/^\//, '');
        }
        return undefined;
    }
}
